import { Card, CardContent, Grid, Typography, Stack } from "@mui/material";
import { FILE_UPLOAD_TYPE, RELATION_TYPE } from "../constant";
import FileStatus from "./FileStatus";
import { isEmpty } from "lodash";

const ExtraDocumment = ({ details, onSuccess }) => {

    const uploadFileBody = {
        customer_id: details.customer_id,
        loan_id: details.loan_id,
        relation_id: details.relation_id,
        doc_name: details.name
    }

    const customerDoc = details?.customer_docs
    const memeber = details?.relation_type

    const fileDetails = details?.relation_id === 0 ? appilcantDocument(customerDoc) : memberDocument(memeber, customerDoc)
    const filteredData = fileDetails?.filter(item => !isEmpty(item))

    return (
        <Card sx={{ p: 3, boxShadow: 3, borderRadius: 2, mt: 3 }}>
            {/* Title */}
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ mb: 2, borderBottom: 1, borderColor: 'divider', pb: 1 }}
            >
                <Typography variant="h4" sx={{ fontWeight: 'bold', fontFamily: 'sans-serif', color: 'primary.main' }}>
                    {details?.relation_type.charAt(0).toUpperCase() + details?.relation_type.slice(1)} Documents
                </Typography>
            </Stack>

            <CardContent>
                <Grid container spacing={2} columns={{ xs: 1, sm: 12 }}>
                    {filteredData.map((item, index) => (
                        <Grid item xs={12} sm={3} key={index}>
                            <FileStatus label={item.file_type?.toUpperCase().replaceAll('_', ' ')} fileType={item.file_type} downloadUrl={item.download_url} details={uploadFileBody} onSuccess={onSuccess}/>
                        </Grid>
                    ))}
                </Grid>
            </CardContent>

        </Card>
    );
};

export default ExtraDocumment;

const memberDocument = (memeber = {}, customerDoc = []) => [
    {
        file_type: FILE_UPLOAD_TYPE.PROFILE_PHOTO,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.PROFILE_PHOTO)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.ELECTRICITY_BILL,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.ELECTRICITY_BILL)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.FI_REPORT,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.FI_REPORT)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.APPLICATION_FORM,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.APPLICATION_FORM)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.AGREEMENT_PHOTOS,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.AGREEMENT_PHOTOS)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.CHEQUE_PHOTO,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.CHEQUE_PHOTO)?.download_url
    },
    memeber === RELATION_TYPE.GUARANTOR ? {
        file_type: FILE_UPLOAD_TYPE.GUARANTOR_APPLICATION_FORM,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.GUARANTOR_APPLICATION_FORM)?.download_url
    }:
    memeber === RELATION_TYPE.COAPPICANT && {
        file_type: FILE_UPLOAD_TYPE.COAPPLICANT_APPLICATION_FORM,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.COAPPLICANT_APPLICATION_FORM)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.NACH_SIGNING_PHOTO,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.NACH_SIGNING_PHOTO)?.download_url
    },
    customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.PDC_CHEQUE) && {
        file_type: FILE_UPLOAD_TYPE.PDC_CHEQUE,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.PDC_CHEQUE)?.download_url
    }
]

const appilcantDocument = (customerDoc = []) => [
    {
        file_type: FILE_UPLOAD_TYPE.UDHYOG_AADHAR,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.UDHYOG_AADHAR)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.BATTERY_PHOTOS,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.BATTERY_PHOTOS)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.BATTERY_WARRANTY_CARD,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.BATTERY_WARRANTY_CARD)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.LOAN_AGREEMENT,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.LOAN_AGREEMENT)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.PROFILE_PHOTO,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.PROFILE_PHOTO)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.AGREEMENT_PHOTOS,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.AGREEMENT_PHOTOS)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.GSTR,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.GSTR)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.BANK_STATEMENT,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.BANK_STATEMENT)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.ELECTRICITY_BILL,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.ELECTRICITY_BILL)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.OTHER_ID_PROOF,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.OTHER_ID_PROOF)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.NACH,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.NACH)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.VEHICLE_RC,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.VEHICLE_RC)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.VEHICLE_PHOTOS,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.VEHICLE_PHOTOS)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.SALES_PHOTOS,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.SALES_PHOTOS)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.ITR,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.ITR)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.SALES_OBSERVATION_SHEET,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.SALES_OBSERVATION_SHEET)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.REMOTE_FILE_DOCS,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.REMOTE_FILE_DOCS)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.BATTERY_INVOICE,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.BATTERY_INVOICE)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.FI_REPORT,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.FI_REPORT)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.VEHICLE_INSURANCE,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.VEHICLE_INSURANCE)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.VEHICLE_INVOICE,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.VEHICLE_INVOICE)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.VEHICLE_QUOTATION,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.VEHICLE_QUOTATION)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.VOTER_ID,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.VOTER_ID)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.DRIVING_LICENCE,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.DRIVING_LICENCE)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.BALANCE_SHEET,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.BALANCE_SHEET)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.APPLICATION_FORM,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.APPLICATION_FORM)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.OTHER_DOCS,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.OTHER_DOCS)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.SALE_DEED,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.VEHICLE_LOAN_DOC && doc?.other_document_type === FILE_UPLOAD_TYPE.SALE_DEED)?.download_url
    },
    {
        file_type: FILE_UPLOAD_TYPE.MARGIN_MONEY_RECEIPT,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.VEHICLE_LOAN_DOC && doc?.other_document_type === FILE_UPLOAD_TYPE.MARGIN_MONEY_RECEIPT)?.download_url
    },
    customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.DELIVERY_ORDER) && {
        file_type: FILE_UPLOAD_TYPE.DELIVERY_ORDER,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.DELIVERY_ORDER)?.download_url
    },
    customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.PDC_CHEQUE) && {
        file_type: FILE_UPLOAD_TYPE.PDC_CHEQUE,
        download_url: customerDoc?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.PDC_CHEQUE)?.download_url
    }
]